<div style="display: block">
  <canvas baseChart [data]="pieChartData" [type]="pieChartType" height="24" width="24" [options]="pieChartOptions"></canvas>
</div>